"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateChats = void 0;
const uuid_1 = require("uuid");
const mappers_1 = require("../../mappers");
const utils_1 = require("../../utils");
const UserInfoChat_1 = require("./UserInfoChat");
const PrivateChatSocketUpdateObservable_1 = require("./PrivateChatSocketUpdateObservable");
const PrivateChatMessageReadObservable_1 = require("./PrivateChatMessageReadObservable");
const BasePrivateChats_1 = require("./BasePrivateChats");
class PrivateChats extends BasePrivateChats_1.BasePrivateChats {
    constructor(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage) {
        super(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this.isChatSearchCleared = false;
        this.removeListeners = [];
        this.changeListeners = [];
        this.updateUnreadChatCount = (chatList) => {
            chatList.unreadChatCount++;
        };
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.socketAdapter = socketAdapter;
        this.config = config;
        this.userDirectory = userDirectory;
        this.hhnStorage = hhnStorage;
        this.privateChatSocketUpdateObservable =
            new PrivateChatSocketUpdateObservable_1.PrivateChatSocketUpdateObservable(this.getChatsStorage(), httpAdapter, organizationUser, userDirectory);
        this.privateChatMessageReadObservable =
            new PrivateChatMessageReadObservable_1.PrivateChatMessageReadObservable(this.hhnStorage.chatsStorage, organizationUser);
    }
    init() {
        if (this.removeListeners && this.removeListeners.length > 0) {
            throw new Error("Panic: Listeners should have been destoryed during unmount!!!");
        }
        this.removeListeners.push(this.chatLogUpdateListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.updateChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.organizationUser
            .getNetworkManager()
            .registerSocketAuthSuccessListener((lastHeartbeatReceivedAt, abortContext) => __awaiter(this, void 0, void 0, function* () {
            yield this.syncChats(lastHeartbeatReceivedAt, abortContext);
            this.notifyChange();
        })));
    }
    destroy() {
        this.removeAllListeners();
    }
    registerChangeListener(cb) {
        const id = (0, uuid_1.v4)();
        this.changeListeners.push({ id, cb });
        return () => {
            this.changeListeners = this.changeListeners.filter(listner => listner.id !== id);
        };
    }
    notifyChange() {
        this.changeListeners.forEach(l => l.cb(this.getChats()));
    }
    getChat(groupId) {
        return this.getChatFromStorage(groupId);
    }
    removeAllListeners() {
        this.removeListeners.forEach(removeListener => removeListener());
        this.removeListeners = [];
    }
    clearChatSearch() {
        this.isChatSearchCleared = true;
        this.fetchChats();
    }
    fetchChats() {
        return __awaiter(this, void 0, void 0, function* () {
            const chatList = this.getChats();
            if (chatList.hasNext) {
                const chatRequestBody = this.buildFetchChatsRequest();
                yield this.fetchGroupChatList(chatRequestBody);
                this.notifyChange();
            }
        });
    }
    syncChats(lastHeartbeatReceivedAt, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            const chatType = this.getChatType();
            const chatRequestBody = {
                chatType,
                hiddenChats: false,
                lastSyncedAt: lastHeartbeatReceivedAt,
                total: 0,
                limit: utils_1.HHNConstants.SYNC_PAGINATION_LIMIT,
            };
            const chatListResponse = yield this.httpAdapter
                .getChatAdapter()
                .syncPrivateChatList(chatRequestBody, this.organizationUser.getOrganization().organizationId, abortContext);
            if (!chatListResponse.isAborted) {
                const newChats = yield (0, mappers_1.privateChatsMapper)(chatListResponse.data);
                this.populateChatList(newChats, "PREPEND", (existingChats, newChats) => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { chats, limit, hasNext, total, page } = newChats, rest = __rest(newChats, ["chats", "limit", "hasNext", "total", "page"]);
                    return Object.assign(Object.assign({}, this.pageData(existingChats)), rest);
                }, true);
            }
        });
    }
    pageData(chats) {
        return {
            limit: chats.limit,
            hasNext: chats.hasNext,
            total: chats.total,
            page: chats.page,
        };
    }
    getChats() {
        return this.getChatsStorage().getChatListByType(this.getGroupType());
    }
    setChats(chatList) {
        this.getChatsStorage().setChatListByType(this.getGroupType(), chatList);
    }
    // @ts-ignore
    getStoredChat(chatId) {
        const chatList = this.getChats();
        if (chatList) {
            const userInfo = this.userDirectory.getUserInfo(chatId);
            if (userInfo)
                return this.getOrCreateChatFromStorage(chatId, userInfo, false);
        }
    }
    getFreshChat(id, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const chatInfoResponse = yield this.fetchChatInfo(id, undefined, context);
            if (!chatInfoResponse.isAborted) {
                this.getOrCreateChatFromStorage(id, chatInfoResponse.data, true);
                this.notifyChange();
            }
        });
    }
    fetchChatInfo(chatId, source, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const userInfoResponse = yield this.httpAdapter
                .getUserDirectoryAdapter()
                .getUserInfo(chatId, source, context);
            if (!userInfoResponse.isAborted) {
                const mappedInfo = (0, mappers_1.userInfoMapper)(userInfoResponse.data);
                return (0, utils_1.CompletedResult)(mappedInfo);
            }
            return utils_1.AbortedResult;
        });
    }
    getUnreadMessageCount(chatId) {
        var _a;
        return (((_a = this.getChatsStorage().getChatByGroupType(this.getGroupType(), chatId)) === null || _a === void 0 ? void 0 : _a.unreadCount) || 0);
    }
    getLastMessageRead(chatId) {
        const chat = this.getChatsStorage().getChatByGroupType(this.getGroupType(), chatId);
        if (chat) {
            return chat.lastMessageRead;
        }
        return undefined;
    }
    getIsMember() {
        // Private chats - users are always members of their own private conversations
        return true;
    }
    getChatFromStorage(chatId) {
        return this.hhnStorage.chatStorage.getPrivateChat(chatId);
    }
    touchChat(chatId) {
        return this.hhnStorage.chatStorage.touchPrivateChat(chatId);
    }
    getOrCreateChatFromStorage(chatId, userInfo, shouldMergeGroupInfo) {
        let chat = this.getChatFromStorage(chatId);
        if (!chat) {
            chat = new UserInfoChat_1.UserInfoChat(userInfo, this.organizationUser, this.config, this.httpAdapter, this.socketAdapter, this.userDirectory, this.hhnStorage, this);
            chat.init();
            this.hhnStorage.chatStorage.addChatByType(this.getGroupType(), chat);
        }
        else {
            /*
            When a user opens a chat for the first time, getStoredChat is called and enters the 'if' condition of this method, creating the chat in storage. Then, getFreshChat is called, and we need to merge the chatInfo with the latest chatInfo returned from getFreshChat. The second time the user opens the chat, getStoredChat is called and enters the 'else' block, but we already have the latest information, so there is no need to merge or update chatInfo.
      
            Example:
            User opens chat 1:
              getStoredChat - chatStorage.chat(P) - Create
              getFreshChat - chatStorage.chat(P) <- (F) - Current (Merging) - Proposed (Overwrite)
      
            User opens chat 2
      
            User opens chat 1 again:
              getStoredChat - chatStorage.chat(F) <- Current (Overwrite) - Proposed (Do nothing)
              getFreshChat - chatStorage.chat(F) <- (F) - Current (Merging) - Proposed (Overwrite)
            */
            if (shouldMergeGroupInfo) {
                chat.updateChatInfo(Object.assign(Object.assign({}, chat.chatInfo), userInfo));
            }
        }
        return chat;
    }
    updateChatListener(cb) {
        return this.privateChatSocketUpdateObservable.updateChatListener(cb, this.getChatType(), this.getGroupType(), true);
    }
    chatLogUpdateListener(cb) {
        return this.privateChatMessageReadObservable.chatMessageReadListener(cb, this.getChatType(), this.getGroupType());
    }
    getChatsStorage() {
        return this.hhnStorage.chatsStorage;
    }
}
exports.PrivateChats = PrivateChats;
